<template>
  <notice :class="$style.errors__notice" error :text="text" :type="noticeType" />
</template>

<script>
import Notice from '@/components/notices/Notice'

export default {
  components: {
    Notice
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    noticeText: {
      type: String,
      default: `<p style="margin: 2rem 3rem; font-size: 14px">Ошибка!</p>`
    }
  },
  computed: {
    noticeData() {
      return this.$store.getters.noticeData
    },

    noticeType() {
      return this.$store.getters.noticeType
    },

    text() {
      return this.noticeData ?? this.noticeText
    }
  }
}
</script>

<style lang="scss" module>
@import '@/assets/styles/breakpoints';

.errors {
  &__notice {
    position: fixed;
    top: 30%;
    left: 30%;
    right: 30%;
    z-index: 100;
    width: 40%;
  }
}

@include for-tablet {
  .errors {
    &__notice {
      left: 20%;
      right: 20%;
      width: 60%;
    }
  }
}
</style>
